import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { GetCurrentUser, IsBillingUser } from '../../domain/interactors/account';
import { MddHttpService } from '../mdd-http.service';

@Injectable()
export class BillingGuard {
    private getCurrentUser: GetCurrentUser;
    private isBillingUser = new IsBillingUser();

    constructor(
        private router: Router,
        http: MddHttpService
    ) {
        this.getCurrentUser = new GetCurrentUser(http);
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const dashboardRequested = route.paramMap.get('name');
        if (dashboardRequested === 'dfa' || dashboardRequested === 'pds') {
            return true;
        } else {
            return this.canLoad();
        }

        /* if (await this.canLoad()) {
      return true;
    } else {
     
      // DFA/PDS dashboards are free, the user can still access them. All
      // others will return false and redirect to the billing page
      // TODO: Users will eventually be able to change their dashboard's name.
      // When this happens, we need to get the LIST_PRICE of the dashboard
      // and return price === 0
      return dashboardRequested === 'dfa' || dashboardRequested === 'pds';
    } */
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.canActivate(route, state);
    }

    canLoad(): Promise<boolean> {
        return this.getCurrentUser
            .execute()
            .catch(() => {})
            .then((user) => {
                if (user && !user.terminationPeriod) {
                    if (!user.billingSetup && user.trialDaysLeft === 0) {
                        if (this.isBillingUser.execute(user)) {
                            this.router.navigateByUrl('/billing');
                        } else {
                            this.router.navigateByUrl('/error/billing');
                        }

                        return false;
                    }
                }

                return true;
            });
    }
}
